<rl-dialog-window (onCancel)="cancel()" (onConfirm)="confirmClick()" [validate]="validateForm" [title]="isFile ? 'citation.action.mark.file.as.broken.confirm' : 'citation.action.report_broken_link.confirm'">
    <div class="modal-section no-margin">
        <p class="semi-large-text no-margin" [innerHTML]="warningLabel">{{warningLabel}}</p>
        <form class="form-flex editable-content border-rows">
            <fieldset>
                <div class="form-flex-row no-border">
                    <div>
                        <label for="feedback">{{'citation.action.report_broken_file.add_comment' | translate}}<span class="must-astrix" *ngIf="isFeedbackMandatory">*</span>:</label>
                    </div>
                </div>
                <div class="form-flex-row">
                    <div class="form-flex-input">
                        <textarea class="form-control form-input-bg-color" value="citation.action.report_broken_file.add_comment" id="feedback" name="feedback" [(ngModel)]="feedback" cols="30" rows="2"></textarea>
                    </div>
                </div>
                <div *ngIf="displayFeedbackWarning" class="input-error-message error-message" role="alert" aria-live="assertive">
                    {{'citation.action.report_broken_warningMsg' | translate}}
                </div>
            </fieldset>
            <rl-file-upload *ngIf="displayUploadFile" [id]="'fileUpload'" [uploadType]="'MarkAsBroken'" [displayUploadFileButton]="true" (onUpload)="onfileUploaded($event)" [acceptedTypes]="'all'"></rl-file-upload>
        </form>
    </div> 
</rl-dialog-window> 